import './style.modules.scss'

import {
  BrandIcon,
  BrandIconColor,
  BrandIconId,
  LinkTarget
} from '@ampcore/adel-react'
import { SpacerSpacing } from '@ampcore/adel-react'
import { stripHtml } from '@ampcore/string-format'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React from 'react'

export type LogoutNotice = {
  icon: BrandIconId
  color?: BrandIconColor
  url?: string
  heading?: string
  target?: LinkTarget
  text?: string
  subtext?: string
  testId?: string
  analyticsName?: string
}

export type LogoutNoticesProps = {
  analyticsName: string
  notices: LogoutNotice[]
  randomize?: boolean
  componentSpacing?: SpacerSpacing
  testId?: string
}

export const LogoutNotices: React.FC<LogoutNoticesProps> = (
  props: LogoutNoticesProps
) => {
  const { analyticsName, notices, randomize, componentSpacing, testId } = props
  const atb = new AnalyticsTagBuilder()
    .setDefaultName('Logout Page')
    .setAnalyticsName(analyticsName)

  const getStrippedHeading = (heading?: string) => {
    const noSup = heading?.replace(/<sup[^>]*>.*?<\/sup>/gi, '')
    const plainText = stripHtml(noSup)
    return plainText?.split(/\s+/).slice(0, 3).join(' ')
  }
  const noticesList = Array.isArray(notices) ? notices : [notices]
  // add key to track original index
  const noticesWithIndex = noticesList.map((notice, index) => ({
    ...notice,
    key: index,
    strippedHeading: getStrippedHeading(notice.heading)
  }))

  const displayNotices = randomize
    ? [...noticesWithIndex].sort(() => Math.random() - 0.5)
    : noticesWithIndex

  return (
    <section
      className={`LogoutNotices ${
        componentSpacing && componentSpacing == SpacerSpacing.TOP
          ? 'u-marginTop32'
          : 'LogoutNotices--stacked'
      } u-sm-marginHoriz32 u-marginLeft48`}
      data-testid={testId}
    >
      {displayNotices.map(notice => (
        <div
          key={notice.key}
          className="u-block u-md-flex u-lg-flex u-sm-marginBottom32 u-md-marginBottom48 u-marginBottom48"
          data-testid={testId ? `${testId}-notice-${notice.key}` : null}
        >
          <div className="u-sm-marginBottom16 u-marginRight32">
            <BrandIcon
              className={'LogoutNotices-icon'}
              icon={notice.icon}
              color={notice.color}
              fill={true}
            />
          </div>
          <div>
            <div className="u-textPrimary u-textDefault u-marginBottom4 u-md-marginBottom8 u-lg-marginBottom20">
              {notice.url ? (
                <a
                  className="Link u-textBold u-textSizeMsr"
                  href={notice.url}
                  target={notice.target}
                  data-testid={
                    testId ? `${testId}-notice-${notice.key}-link` : null
                  }
                  {...atb.dataAnalyticAttribute(
                    notice.analyticsName,
                    notice.strippedHeading
                  )}
                  dangerouslySetInnerHTML={{ __html: notice.heading || '' }}
                />
              ) : (
                <span
                  className="u-textBold u-textSizeMsr"
                  dangerouslySetInnerHTML={{ __html: notice.heading || '' }}
                />
              )}
            </div>
            {notice.text && (
              <div
                className="u-textPrimary u-textDefault u-marginBottom4 u-md-marginBottom8 u-lg-marginBottom20 u-textSizeMsr"
                dangerouslySetInnerHTML={{ __html: notice.text || '' }}
              />
            )}
            {notice.subtext && (
              <div
                className="LogoutNotices-subText u-textPrimary u-textDefault u-textSizeMsrm1"
                dangerouslySetInnerHTML={{ __html: notice.subtext }}
              />
            )}
          </div>
        </div>
      ))}
    </section>
  )
}
